module.exports = __webpack_public_path__ + "img/report_img_202205.45867251.png";